exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-menu{padding:0 0 3rem}.tab-menu .tabs-on-card{margin-bottom:0!important;padding:.5rem 0 0;background-color:#f5f5f5}.tab-menu .tabs-on-card ul{border-bottom:none!important}.tab-menu .tabs-on-card.is-boxed li a{border:0 solid transparent!important;border-radius:4px 4px 0 0!important;background-color:transparent;color:#4a4a4a;margin-bottom:0;transition:background-color .15s ease,color .15s ease}.tab-menu .tabs-on-card.is-boxed li:hover a{background-color:hsla(0,0%,75%,.475);border:0 solid hsla(0,0%,75%,.475)!important;color:#522687!important}.tab-menu .tabs-on-card.is-boxed li.is-active a{background-color:#fff;border:0 solid #fff!important;color:#522687!important;font-weight:600;box-shadow:0 14px 20px #00000029}.tab-menu .tabs-on-card.is-boxed li a .icon{margin-right:.4em}.tab-menu .tab-card{padding:1.5rem 3rem 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f58ab58","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/cultura/views/ProcessDetail.vue
// module id = 1495
// module chunks = 2